import { supabase } from "./config";

import React from 'react'

function Sign() {
    const sign=()=>{
        supabase.auth.signInWithOAuth({provider:'google',redirectTo:'teal-sopapillas-cdeb74.netlify.app'}).then((res)=>{
            console.log(res.data);
            
        })
    }
  return (
    <div className="sign">
      <h1 className="signtxt">Sign up</h1>
      <button onClick={sign} className="signbtn">Sign up with Google</button>
    </div>
  )
}

export default Sign
